import * as React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import {
  ChakraProvider,
  Box,
  VStack,
  Grid,
  extendTheme,
  ThemeConfig,
  Heading,
} from "@chakra-ui/react";
import { WeekdaySelector } from "./WeekdaySelector";
import { ColorModeSwitcher } from "./ColorModeSwitcher";

const themeConfig: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

export const theme = extendTheme({ config: themeConfig });

export const App = () => (
  <ChakraProvider theme={theme}>
    <ColorModeSwitcher />
    <Box textAlign="center">
      <Router>
        <Switch>
          <Route
            path="/schedule"
            render={() => (
              <Grid minH="100vh" p={3}>
                <VStack spacing={8}>
                  <Heading size="4xl" color="teal">
                    Flock
                  </Heading>
                  <WeekdaySelector />
                </VStack>
              </Grid>
            )}
          />
          <Route path="/insights" render={() => <Heading>Insights</Heading>} />
          <Redirect to="/schedule" />
        </Switch>
      </Router>
    </Box>
  </ChakraProvider>
);
